//
//
//
//
//
//
//
//

export default {
  name: 'i-count',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data(){
    return {
      result: this.value,
    };
  },
  watch: {
    value(cur){
      this.result = cur;
    },
    result(cur){
      this.$emit('input', cur);
    },
  },
  methods: {
    onReduce(){
      if(this.result > this.min){
        this.result = this.result - this.step;
      }
    },

    onPlus(){
      if(this.max > this.result){
        this.result = this.result + this.step;
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/ICount/ICount.vue